 <script>
    import userStore from '../../store/user/user'
    import { navigate } from "svelte-routing"
    let user

    userStore.subscribe(value => {
     	user = value
    })

    if (user.isLoaded && !user.isLogged) {
         navigate('/login')
    }
     if (!user.isLoaded && !user.errorGetData) {
         userStore.tryLogin()
     }
</script>
<div>
 {#if user.isLoaded && user.isLogged}
    <slot />
 {/if}

</div>


